/**
 * Form step components for the loan application form
 */
import React from 'react';

// Step 1: Choose Loan Type
export const LoanTypeStep = ({ formData, handleInputChange, errors }) => (
  <div className="form-step">
    <h3 className="step-title">Choose Loan Type</h3>
    <div className="form-group">
      <label className="form-label">
        What best describes you? <span className="required">*</span>
      </label>
      <div className={`radio-options ${errors.applicantType ? 'input-error' : ''}`}>
        <label className="radio-option">
          <input
            type="radio"
            name="applicantType"
            value="Employed Individual"
            checked={formData.applicantType === "Employed Individual"}
            onChange={handleInputChange}
          />
          <span>I am an Employed Individual (Personal Loan)</span>
        </label>
        <label className="radio-option">
          <input
            type="radio"
            name="applicantType"
            value="Business Owner"
            checked={formData.applicantType === "Business Owner"}
            onChange={handleInputChange}
          />
          <span>I am a Business Owner / Entrepreneur</span>
        </label>
      </div>
      {errors.applicantType && <span className="error-message">{errors.applicantType}</span>}
    </div>
  </div>
);

// Path A - Employed Individual: Personal Details
export const EmployedPersonalStep = ({ formData, handleInputChange, errors }) => (
  <div className="form-step">
    <h3 className="step-title">Personal Details</h3>
    <div className="form-group">
      <label htmlFor="fullName" className="form-label">
        Full Name <span className="required">*</span>
      </label>
      <input
        type="text"
        id="fullName"
        name="fullName"
        className={`form-input ${errors.fullName ? 'input-error' : ''}`}
        placeholder="Enter your full name"
        value={formData.fullName}
        onChange={handleInputChange}
        required
      />
      {errors.fullName && <span className="error-message">{errors.fullName}</span>}
    </div>
    <div className="form-group">
      <label htmlFor="email" className="form-label">
        Email Address <span className="required">*</span>
      </label>
      <input
        type="email"
        id="email"
        name="email"
        className={`form-input ${errors.email ? 'input-error' : ''}`}
        placeholder="Enter your email address"
        value={formData.email}
        onChange={handleInputChange}
        required
      />
      {errors.email && <span className="error-message">{errors.email}</span>}
    </div>
    <div className="form-group">
      <label htmlFor="phoneNumber" className="form-label">
        Phone Number <span className="required">*</span> (WhatsApp preferred)
      </label>
      <input
        type="tel"
        id="phoneNumber"
        name="phoneNumber"
        className={`form-input ${errors.phoneNumber ? 'input-error' : ''}`}
        placeholder="Enter your phone number"
        value={formData.phoneNumber}
        onChange={handleInputChange}
        required
      />
      {errors.phoneNumber && <span className="error-message">{errors.phoneNumber}</span>}
    </div>
    <div className="form-group">
      <label htmlFor="address" className="form-label">
        Home Address <span className="required">*</span> (City, State)
      </label>
      <input
        type="text"
        id="address"
        name="address"
        className={`form-input ${errors.address ? 'input-error' : ''}`}
        placeholder="Enter your home address"
        value={formData.address}
        onChange={handleInputChange}
        required
      />
      {errors.address && <span className="error-message">{errors.address}</span>}
    </div>
    <div className="form-group">
      <label htmlFor="dateOfBirth" className="form-label">
        Date of Birth <span className="required">*</span>
      </label>
      <input
        type="date"
        id="dateOfBirth"
        name="dateOfBirth"
        className={`form-input ${errors.dateOfBirth ? 'input-error' : ''}`}
        value={formData.dateOfBirth}
        onChange={handleInputChange}
        required
      />
      {errors.dateOfBirth && <span className="error-message">{errors.dateOfBirth}</span>}
    </div>
    <div className="form-group">
      <label className="form-label">
        Employment Category <span className="required">*</span>
      </label>
      <select
        name="employmentCategory"
        className={`form-input ${errors.employmentCategory ? 'input-error' : ''}`}
        value={formData.employmentCategory}
        onChange={handleInputChange}
      >
        <option value="">-- Select Employment Category --</option>
        <option value="IPPIS">IPPIS</option>
        <option value="LAGOS STATE">LAGOS STATE</option>
        <option value="Others">Others</option>
      </select>
      {errors.employmentCategory && <span className="error-message">{errors.employmentCategory}</span>}
    </div>
    <div className="form-group">
      <label className="form-label">
        Monthly Income Range <span className="required">*</span>
      </label>
      <select
        name="monthlyIncome"
        className={`form-input ${errors.monthlyIncome ? 'input-error' : ''}`}
        value={formData.monthlyIncome}
        onChange={handleInputChange}
      >
        <option value="">-- Select Income Range --</option>
        <option value="Below ₦100,000">Below ₦100,000</option>
        <option value="₦100,000 - ₦300,000">₦100,000 - ₦300,000</option>
        <option value="₦300,000 - ₦700,000">₦300,000 - ₦700,000</option>
        <option value="Above ₦700,000">Above ₦700,000</option>
      </select>
      {errors.monthlyIncome && <span className="error-message">{errors.monthlyIncome}</span>}
    </div>
    <div className="form-group">
      <label htmlFor="businessName" className="form-label">
        Employer Name <span className="required">*</span>
      </label>
      <input
        type="text"
        id="businessName"
        name="businessName"
        className={`form-input ${errors.businessName ? 'input-error' : ''}`}
        placeholder="Enter your employer's name"
        value={formData.businessName}
        onChange={handleInputChange}
        required
      />
      {errors.businessName && <span className="error-message">{errors.businessName}</span>}
    </div>
    <div className="form-group">
      <label className="form-label">
        Employment Duration <span className="required">*</span>
      </label>
      <select
        name="yearsInOperation"
        className={`form-input ${errors.yearsInOperation ? 'input-error' : ''}`}
        value={formData.yearsInOperation}
        onChange={handleInputChange}
      >
        <option value="">-- Select Duration --</option>
        <option value="Less than 6 months">Less than 6 months</option>
        <option value="6 months - 2 years">6 months - 2 years</option>
        <option value="Over 2 years">Over 2 years</option>
      </select>
      {errors.yearsInOperation && <span className="error-message">{errors.yearsInOperation}</span>}
    </div>
  </div>
);

// Path A - Employed Individual: Loan Details
export const EmployedLoanDetailsStep = ({ formData, handleInputChange, errors }) => (
  <div className="form-step">
    <h3 className="step-title">Loan Details</h3>
    <div className="form-group">
      <label htmlFor="loanAmount" className="form-label">
        How much do you need? (₦) <span className="required">*</span>
      </label>
      <input
        type="number"
        id="loanAmount"
        name="loanAmount"
        className={`form-input ${errors.loanAmount ? 'input-error' : ''}`}
        placeholder="Enter loan amount"
        value={formData.loanAmount}
        onChange={handleInputChange}
        required
      />
      {errors.loanAmount && <span className="error-message">{errors.loanAmount}</span>}
    </div>
    
    <div className="form-group">
      <label className="form-label">
        Purpose of the Loan <span className="required">*</span>
      </label>
      <select
        name="loanPurpose"
        className={`form-input ${errors.loanPurpose ? 'input-error' : ''}`}
        value={formData.loanPurpose}
        onChange={handleInputChange}
      >
        <option value="">-- Select Purpose --</option>
        <option value="Emergency">Emergency (Medical, rent, etc.)</option>
        <option value="School fees">School fees / Education</option>
        <option value="Family support">Family support</option>
        <option value="Other">Other</option>
      </select>
      {errors.loanPurpose && <span className="error-message">{errors.loanPurpose}</span>}
    </div>
    
    {formData.loanPurpose === "Other" && (
      <div className="form-group">
        <label htmlFor="otherPurpose" className="form-label">
          Please specify <span className="required">*</span>
        </label>
        <input
          type="text"
          id="otherPurpose"
          name="otherPurpose"
          className={`form-input ${errors.otherPurpose ? 'input-error' : ''}`}
          placeholder="Enter loan purpose"
          value={formData.otherPurpose}
          onChange={handleInputChange}
        />
        {errors.otherPurpose && <span className="error-message">{errors.otherPurpose}</span>}
      </div>
    )}
    
    <div className="form-group">
      <label className="form-label">
        Preferred Repayment Duration <span className="required">*</span>
      </label>
      <select
        name="repaymentDuration"
        className={`form-input ${errors.repaymentDuration ? 'input-error' : ''}`}
        value={formData.repaymentDuration}
        onChange={handleInputChange}
      >
        <option value="">-- Select Duration --</option>
        <option value="1-3 months">1-3 months</option>
        <option value="3-6 months">3-6 months</option>
        <option value="6-12 months">6-12 months</option>
      </select>
      {errors.repaymentDuration && <span className="error-message">{errors.repaymentDuration}</span>}
    </div>
    
    <div className="form-group">
      <label className="form-label">
        Do you currently have other loans? <span className="required">*</span>
      </label>
      <select
        name="existingLoans"
        className={`form-input ${errors.existingLoans ? 'input-error' : ''}`}
        value={formData.existingLoans}
        onChange={handleInputChange}
      >
        <option value="">-- Please select --</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>
      {errors.existingLoans && <span className="error-message">{errors.existingLoans}</span>}
    </div>
    
    {formData.existingLoans === "Yes" && (
      <div className="form-group">
        <label className="form-label">
          Are you servicing those loans? <span className="required">*</span>
        </label>
        <select
          name="servicing"
          className={`form-input ${errors.servicing ? 'input-error' : ''}`}
          value={formData.servicing}
          onChange={handleInputChange}
        >
          <option value="">-- Please select --</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        {errors.servicing && <span className="error-message">{errors.servicing}</span>}
      </div>
    )}
  </div>
);

// Path A - Employed Individual: Additional Information
export const EmployedAdditionalStep = ({ formData, handleInputChange, errors }) => (
  <div className="form-step">
    <h3 className="step-title">Additional Information</h3>
    
    {formData.existingLoans === "Yes" && (
      <>
        <div className="form-group">
          <label htmlFor="totalBorrowing" className="form-label">
            Total borrowing exposure (amount) <span className="required">*</span>
          </label>
          <input
            type="number"
            id="totalBorrowing"
            name="totalBorrowing"
            className={`form-input ${errors.totalBorrowing ? 'input-error' : ''}`}
            placeholder="Enter total amount"
            value={formData.totalBorrowing}
            onChange={handleInputChange}
            required
          />
          {errors.totalBorrowing && <span className="error-message">{errors.totalBorrowing}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="borrowingDate" className="form-label">
            Date of borrowing <span className="required">*</span>
          </label>
          <input
            type="date"
            id="borrowingDate"
            name="borrowingDate"
            className={`form-input ${errors.borrowingDate ? 'input-error' : ''}`}
            value={formData.borrowingDate}
            onChange={handleInputChange}
            required
          />
          {errors.borrowingDate && <span className="error-message">{errors.borrowingDate}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="currentExposure" className="form-label">
            Exposure as at date <span className="required">*</span>
          </label>
          <input
            type="number"
            id="currentExposure"
            name="currentExposure"
            className={`form-input ${errors.currentExposure ? 'input-error' : ''}`}
            placeholder="Enter current exposure"
            value={formData.currentExposure}
            onChange={handleInputChange}
            required
          />
          {errors.currentExposure && <span className="error-message">{errors.currentExposure}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="lendingInstitutions" className="form-label">
            Name of institution(s) borrowed from <span className="required">*</span>
          </label>
          <input
            type="text"
            id="lendingInstitutions"
            name="lendingInstitutions"
            className={`form-input ${errors.lendingInstitutions ? 'input-error' : ''}`}
            placeholder="Enter institution names"
            value={formData.lendingInstitutions}
            onChange={handleInputChange}
            required
          />
          {errors.lendingInstitutions && <span className="error-message">{errors.lendingInstitutions}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="bvn" className="form-label">
            BVN <span className="required">*</span>
          </label>
          <input
            type="text"
            id="bvn"
            name="bvn"
            className={`form-input ${errors.bvn ? 'input-error' : ''}`}
            placeholder="Enter your BVN"
            value={formData.bvn}
            onChange={handleInputChange}
            required
          />
          {errors.bvn && <span className="error-message">{errors.bvn}</span>}
        </div>
      </>
    )}

    <div className="form-group">
      <label className="form-label">
        Preferred Contact Method <span className="required">*</span>
      </label>
      <div className={`radio-options ${errors.preferredContactMethod ? 'input-error' : ''}`}>
        <label className="radio-option">
          <input
            type="radio"
            name="preferredContactMethod"
            value="WhatsApp"
            checked={formData.preferredContactMethod === "WhatsApp"}
            onChange={handleInputChange}
          />
          <span>WhatsApp</span>
        </label>
        <label className="radio-option">
          <input
            type="radio"
            name="preferredContactMethod"
            value="Phone Call"
            checked={formData.preferredContactMethod === "Phone Call"}
            onChange={handleInputChange}
          />
          <span>Phone Call</span>
        </label>
        <label className="radio-option">
          <input
            type="radio"
            name="preferredContactMethod"
            value="Email"
            checked={formData.preferredContactMethod === "Email"}
            onChange={handleInputChange}
          />
          <span>Email</span>
        </label>
      </div>
      {errors.preferredContactMethod && <span className="error-message">{errors.preferredContactMethod}</span>}
    </div>
    
    <div className="form-group consent-group">
      <label className="checkbox-container">
        <input
          type="checkbox"
          name="consent"
          checked={formData.consent}
          onChange={handleInputChange}
          className={errors.consent ? 'input-error' : ''}
        />
        <span className="checkmark"></span>
        <span className="consent-text" style={{ color: 'white' }}>
          I agree to be contacted by Orbit Financial Services and accept the privacy policy. <span className="required">*</span>
        </span>
      </label>
      {errors.consent && <span className="error-message">{errors.consent}</span>}
    </div>
  </div>
);

// Path B - Business Owner: Business Profile
export const BusinessProfileStep = ({ formData, handleInputChange, errors }) => (
  <div className="form-step">
    <h3 className="step-title">Business Profile</h3>
    <div className="form-group">
      <label htmlFor="fullName" className="form-label">
        Full Name (Contact Person) <span className="required">*</span>
      </label>
      <input
        type="text"
        id="fullName"
        name="fullName"
        className={`form-input ${errors.fullName ? 'input-error' : ''}`}
        placeholder="Enter contact person's name"
        value={formData.fullName}
        onChange={handleInputChange}
        required
      />
      {errors.fullName && <span className="error-message">{errors.fullName}</span>}
    </div>
    <div className="form-group">
      <label htmlFor="businessName" className="form-label">
        Business Name <span className="required">*</span>
      </label>
      <input
        type="text"
        id="businessName"
        name="businessName"
        className={`form-input ${errors.businessName ? 'input-error' : ''}`}
        placeholder="Enter business name"
        value={formData.businessName}
        onChange={handleInputChange}
        required
      />
      {errors.businessName && <span className="error-message">{errors.businessName}</span>}
    </div>
    <div className="form-group">
      <label htmlFor="email" className="form-label">
        Email Address <span className="required">*</span>
      </label>
      <input
        type="email"
        id="email"
        name="email"
        className={`form-input ${errors.email ? 'input-error' : ''}`}
        placeholder="Enter business email"
        value={formData.email}
        onChange={handleInputChange}
        required
      />
      {errors.email && <span className="error-message">{errors.email}</span>}
    </div>
    <div className="form-group">
      <label htmlFor="phoneNumber" className="form-label">
        Phone Number <span className="required">*</span> (WhatsApp preferred)
      </label>
      <input
        type="tel"
        id="phoneNumber"
        name="phoneNumber"
        className={`form-input ${errors.phoneNumber ? 'input-error' : ''}`}
        placeholder="Enter business phone number"
        value={formData.phoneNumber}
        onChange={handleInputChange}
        required
      />
      {errors.phoneNumber && <span className="error-message">{errors.phoneNumber}</span>}
    </div>
    <div className="form-group">
      <label htmlFor="address" className="form-label">
        Business Address <span className="required">*</span> (City, State)
      </label>
      <input
        type="text"
        id="address"
        name="address"
        className={`form-input ${errors.address ? 'input-error' : ''}`}
        placeholder="Enter business address"
        value={formData.address}
        onChange={handleInputChange}
        required
      />
      {errors.address && <span className="error-message">{errors.address}</span>}
    </div>
    <div className="form-group">
      <label className="form-label">
        Nature of Business <span className="required">*</span>
      </label>
      <select
        name="businessNature"
        className={`form-input ${errors.businessNature ? 'input-error' : ''}`}
        value={formData.businessNature}
        onChange={handleInputChange}
      >
        <option value="">-- Select Business Type --</option>
        <option value="Retail">Retail</option>
        <option value="Services">Services</option>
        <option value="Manufacturing">Manufacturing</option>
        <option value="Agriculture">Agriculture</option>
        <option value="Tech">Tech</option>
        <option value="Other">Other</option>
      </select>
      {errors.businessNature && <span className="error-message">{errors.businessNature}</span>}
    </div>
    {formData.businessNature === "Other" && (
      <div className="form-group">
        <label htmlFor="otherBusinessNature" className="form-label">
          Please specify <span className="required">*</span>
        </label>
        <input
          type="text"
          id="otherBusinessNature"
          name="otherBusinessNature"
          className={`form-input ${errors.otherBusinessNature ? 'input-error' : ''}`}
          placeholder="Specify business nature"
          value={formData.otherBusinessNature}
          onChange={handleInputChange}
        />
        {errors.otherBusinessNature && <span className="error-message">{errors.otherBusinessNature}</span>}
      </div>
    )}
    <div className="form-group">
      <label className="form-label">
        Years in Operation <span className="required">*</span>
      </label>
      <select
        name="yearsInOperation"
        className={`form-input ${errors.yearsInOperation ? 'input-error' : ''}`}
        value={formData.yearsInOperation}
        onChange={handleInputChange}
      >
        <option value="">-- Select Duration --</option>
        <option value="Less than 1 year">Less than 1 year</option>
        <option value="1-3 years">1-3 years</option>
        <option value="Over 3 years">Over 3 years</option>
      </select>
      {errors.yearsInOperation && <span className="error-message">{errors.yearsInOperation}</span>}
    </div>
    <div className="form-group">
      <label className="form-label">
        Monthly Revenue Range <span className="required">*</span>
      </label>
      <select
        name="monthlyIncome"
        className={`form-input ${errors.monthlyIncome ? 'input-error' : ''}`}
        value={formData.monthlyIncome}
        onChange={handleInputChange}
      >
        <option value="">-- Select Revenue Range --</option>
        <option value="Below ₦300,000">Below ₦300,000</option>
        <option value="₦300,000 - ₦1,000,000">₦300,000 - ₦1,000,000</option>
        <option value="₦1,000,000 - ₦5,000,000">₦1,000,000 - ₦5,000,000</option>
        <option value="Above ₦5,000,000">Above ₦5,000,000</option>
      </select>
      {errors.monthlyIncome && <span className="error-message">{errors.monthlyIncome}</span>}
    </div>
  </div>
);

// Path B - Business Owner: Loan Requirements
export const BusinessLoanStep = ({ formData, handleInputChange, errors }) => (
  <div className="form-step">
    <h3 className="step-title">Loan Requirements</h3>
    <div className="form-group">
      <label htmlFor="loanAmount" className="form-label">
        Loan Amount Required (₦) <span className="required">*</span>
      </label>
      <input
        type="number"
        id="loanAmount"
        name="loanAmount"
        className={`form-input ${errors.loanAmount ? 'input-error' : ''}`}
        placeholder="Enter loan amount"
        value={formData.loanAmount}
        onChange={handleInputChange}
        required
      />
      {errors.loanAmount && <span className="error-message">{errors.loanAmount}</span>}
    </div>
    
    <div className="form-group">
      <label className="form-label">
        Use of Funds <span className="required">*</span>
      </label>
      <select
        name="loanPurpose"
        className={`form-input ${errors.loanPurpose ? 'input-error' : ''}`}
        value={formData.loanPurpose}
        onChange={handleInputChange}
      >
        <option value="">-- Select Purpose --</option>
        <option value="Working capital">Working capital</option>
        <option value="Inventory purchase">Inventory purchase</option>
        <option value="Equipment / asset financing">Equipment / asset financing</option>
        <option value="Project execution">Project execution (contract-based)</option>
        <option value="Invoice discounting">Invoice discounting</option>
        <option value="Green project financing">Green project financing</option>
      </select>
      {errors.loanPurpose && <span className="error-message">{errors.loanPurpose}</span>}
    </div>
    
    <div className="form-group">
      <label className="form-label">
        Preferred Repayment Duration <span className="required">*</span>
      </label>
      <select
        name="repaymentDuration"
        className={`form-input ${errors.repaymentDuration ? 'input-error' : ''}`}
        value={formData.repaymentDuration}
        onChange={handleInputChange}
      >
        <option value="">-- Select Duration --</option>
        <option value="1-3 months">1-3 months</option>
        <option value="3-6 months">3-6 months</option>
        <option value="6-12 months">6-12 months</option>
        <option value="Over 12 months">Over 12 months</option>
      </select>
      {errors.repaymentDuration && <span className="error-message">{errors.repaymentDuration}</span>}
    </div>
    
    <div className="form-group">
      <label className="form-label">
        Do you have existing loans or overdrafts? <span className="required">*</span>
      </label>
      <select
        name="existingLoans"
        className={`form-input ${errors.existingLoans ? 'input-error' : ''}`}
        value={formData.existingLoans}
        onChange={handleInputChange}
      >
        <option value="">-- Please select --</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>
      {errors.existingLoans && <span className="error-message">{errors.existingLoans}</span>}
    </div>
    
    {formData.existingLoans === "Yes" && (
      <div className="form-group">
        <label className="form-label">
          Are you currently servicing them? <span className="required">*</span>
        </label>
        <select
          name="servicing"
          className={`form-input ${errors.servicing ? 'input-error' : ''}`}
          value={formData.servicing}
          onChange={handleInputChange}
        >
          <option value="">-- Please select --</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        {errors.servicing && <span className="error-message">{errors.servicing}</span>}
      </div>
    )}
  </div>
);

// Path B - Business Owner: Additional Information
export const BusinessAdditionalStep = ({ formData, handleInputChange, errors }) => (
  <div className="form-step">
    <h3 className="step-title">Additional Information</h3>
    
    {formData.existingLoans === "Yes" && (
      <>
        <div className="form-group">
          <label htmlFor="totalBorrowing" className="form-label">
            Total borrowing exposure (amount) <span className="required">*</span>
          </label>
          <input
            type="number"
            id="totalBorrowing"
            name="totalBorrowing"
            className={`form-input ${errors.totalBorrowing ? 'input-error' : ''}`}
            placeholder="Enter total amount"
            value={formData.totalBorrowing}
            onChange={handleInputChange}
            required
          />
          {errors.totalBorrowing && <span className="error-message">{errors.totalBorrowing}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="borrowingDate" className="form-label">
            Date of borrowing <span className="required">*</span>
          </label>
          <input
            type="date"
            id="borrowingDate"
            name="borrowingDate"
            className={`form-input ${errors.borrowingDate ? 'input-error' : ''}`}
            value={formData.borrowingDate}
            onChange={handleInputChange}
            required
          />
          {errors.borrowingDate && <span className="error-message">{errors.borrowingDate}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="currentExposure" className="form-label">
            Exposure as at date <span className="required">*</span>
          </label>
          <input
            type="number"
            id="currentExposure"
            name="currentExposure"
            className={`form-input ${errors.currentExposure ? 'input-error' : ''}`}
            placeholder="Enter current exposure"
            value={formData.currentExposure}
            onChange={handleInputChange}
            required
          />
          {errors.currentExposure && <span className="error-message">{errors.currentExposure}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="lendingInstitutions" className="form-label">
            Name of institution(s) borrowed from <span className="required">*</span>
          </label>
          <input
            type="text"
            id="lendingInstitutions"
            name="lendingInstitutions"
            className={`form-input ${errors.lendingInstitutions ? 'input-error' : ''}`}
            placeholder="Enter institution names"
            value={formData.lendingInstitutions}
            onChange={handleInputChange}
            required
          />
          {errors.lendingInstitutions && <span className="error-message">{errors.lendingInstitutions}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="bvn" className="form-label">
            BVN of Director <span className="required">*</span>
          </label>
          <input
            type="text"
            id="bvn"
            name="bvn"
            className={`form-input ${errors.bvn ? 'input-error' : ''}`}
            placeholder="Enter BVN of Director"
            value={formData.bvn}
            onChange={handleInputChange}
            required
          />
          {errors.bvn && <span className="error-message">{errors.bvn}</span>}
        </div>
      </>
    )}

    <div className="form-group">
      <label className="form-label">
        Do you have invoices or contracts with reputable firms? <span className="required">*</span>
      </label>
      <select
        name="hasInvoices"
        className={`form-input ${errors.hasInvoices ? 'input-error' : ''}`}
        value={formData.hasInvoices}
        onChange={handleInputChange}
      >
        <option value="">-- Please select --</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>
      {errors.hasInvoices && <span className="error-message">{errors.hasInvoices}</span>}
    </div>

    <div className="form-group">
      <label className="form-label">
        Preferred Contact Method <span className="required">*</span>
      </label>
      <div className={`radio-options ${errors.preferredContactMethod ? 'input-error' : ''}`}>
        <label className="radio-option">
          <input
            type="radio"
            name="preferredContactMethod"
            value="WhatsApp"
            checked={formData.preferredContactMethod === "WhatsApp"}
            onChange={handleInputChange}
          />
          <span>WhatsApp</span>
        </label>
        <label className="radio-option">
          <input
            type="radio"
            name="preferredContactMethod"
            value="Phone Call"
            checked={formData.preferredContactMethod === "Phone Call"}
            onChange={handleInputChange}
          />
          <span>Phone Call</span>
        </label>
        <label className="radio-option">
          <input
            type="radio"
            name="preferredContactMethod"
            value="Email"
            checked={formData.preferredContactMethod === "Email"}
            onChange={handleInputChange}
          />
          <span>Email</span>
        </label>
      </div>
      {errors.preferredContactMethod && <span className="error-message">{errors.preferredContactMethod}</span>}
    </div>
    
    <div className="form-group consent-group">
      <label className="checkbox-container">
        <input
          type="checkbox"
          name="consent"
          checked={formData.consent}
          onChange={handleInputChange}
          className={errors.consent ? 'input-error' : ''}
        />
        <span className="checkmark"></span>
        <span className="consent-text" style={{ color: 'white' }}>
          I agree to be contacted by Orbit Financial Services and accept the privacy policy. <span className="required">*</span>
        </span>
      </label>
      {errors.consent && <span className="error-message">{errors.consent}</span>}
    </div>
  </div>
);

// Legacy step components (kept for compatibility, can be removed later)
export const PersonalInfoStep = EmployedPersonalStep;
export const BusinessDetailsStep = BusinessProfileStep;
export const LoanDetailsStep = EmployedLoanDetailsStep;
export const AdditionalInfoStep = EmployedAdditionalStep;
